/*
 1. Turn on Developer mode / usb debugging on your Android device,
 2. then do build-android-debug.bat,
 3. transfer the resulting apk to the device, and
 4. install it
 5. go to https://www.gla.ac.uk/uofglife/dashboard/launch.html and click the link, which should launch UofGLife

Attach your Android device to your development machine and ensure you can see it in the Device Manager / Physical pane
You will see a line like this in Android Studio:
   we got launched from URL: uofglife://foo?param=bar", source: https://gla.ac.uk/js/app.4034b2c9.js (1)

*/

const ALLOWED_PROTOCOLS = ['uofglife:']
const ALLOWED_ACTIONS = ['booking']

export function findRoomId (urlString) {
  // from a requestedView string (see router.js)
  const regexpRoomid = /=(\w+)/
  const match = urlString.match(regexpRoomid)
  if (match != null) {
    return match[1]
  } else {
    return undefined
  }
}

export function getAction (urlstring) {
  const u = new URL(urlstring)
  let ret = {}
  // validate it
  if (ALLOWED_PROTOCOLS.indexOf(u.protocol) !== -1) {
    // only actions currently: booking
    // everyone but iOS use 'pathname' but they use host, i guess
    const firstBit = (u.pathname !== '') ? u.pathname : u.hostname
    const action = typeof firstBit === 'string' ? firstBit.replace('//', '') : ''
    if (ALLOWED_ACTIONS.indexOf(action) !== -1) {
      ret = {
        action: action,
        params: processParams(action, u.searchParams)
      }
    } else {
      console.error('Received action ' + action + ' is not supported.')
    }
  } else {
    console.error('Received protocol ' + u.protocol + ' is not supported.')
  }

  return ret
}

function processParams (action, searchParams) {
  let ret = {}

  switch (action) {
    case 'booking': /* we just want the roomid */
      ret['roomId'] = searchParams.get('roomId')
      ret['src'] = searchParams.get('src')
      break
    default:
      console.error('unsupported action ' + action)
  }

  return ret
}
